import { Entity } from './entity.model';

export function getValidation(obj : Entity) : string{
let validation = '';

validation = getDescriptionValidationMessage(obj);

if(!validation){
    validation = getProviderValidationMessage(obj);
}

if(!validation){
    validation = getQueryValidationMessage(obj);
}

return validation;
}

export function getDescriptionValidationMessage(obj : Entity) {
return !obj.Description ? 'Por favor, informe a descrição' : '';
}

export function getProviderValidationMessage(obj : Entity) {
return !obj.Provider.Id ? 'Por favor, selecione um provedor válido' : '';
}

export function getQueryValidationMessage(obj : Entity) {
return !obj.Query ? 'Por favor, informe a query' : '';
}
